var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var data = ref.data;
var v = ref.value;
return [_c('LKButtonReport',{attrs:{"status":v.status,"url":v.url,"filename":v.filename,"tooltip":v.tooltip},on:{"click":function($event){return _vm.$emit('update:status', data, $event)}}})]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }